export const translations = {
  es: {
    brand: { name: "Vargas & Zúñiga", suffix: "Abogados" },
    slogan: "Experiencia · Fidelidad · Eficiencia",
    nav: {
      home: "Inicio",
      studio: "Estudio Jurídico",
      clients: "Clientes",
      lawyers: "Abogados",
      areas: "Áreas de Práctica",
      contact: "Contacto",
    },
    arrows: { prev: "Sección anterior", next: "Sección siguiente" },
    home: {
      eyebrow: "Estudio jurídico · Temuco · Chile",
      lead: "",
      ctaChat: "Conversar con la asistente",
      ctaSections: "Explorar el sitio",
    },
    studio: {
      title: "Estudio Jurídico",
      paragraphs: [
        "Vargas & Zúñiga Abogados es una oficina fundada el año 2005 por los Abogados y Magíster en Derecho Alejandro Vargas C. y Mónica Zúñiga L., ambos egresados el año 2003 de la Universidad Católica de Temuco. Desde sus inicios, la visión de sus fundadores fue la prestación de servicios especializados y personalizados.",
        "A la fecha, el estudio ha patrocinado más de 2.000 clientes con exitosos resultados en un altísimo porcentaje. En más de 20 años de ejercicio, los Abogados del Estudio cuentan con un gran número de alegatos en la mayoría de las Cortes de Apelaciones del País, Excma. Corte Suprema de Justicia y Tribunal Constitucional.",
      ],
      values: [
        {
          k: "Experiencia",
          d: "Más de dos décadas de ejercicio profesional en sede civil, tributaria, laboral y de familia.",
        },
        {
          k: "Fidelidad",
          d: "Acompañamos a nuestros clientes en el tiempo. Cada socio atiende personalmente las consultas.",
        },
        {
          k: "Eficiencia",
          d: "Respuestas claras, estrategias precisas y resultados medibles en cada gestión.",
        },
      ],
    },
    clients: {
      title: "Algunos de nuestros clientes representativos",
      lead: "",
      note: "",
      groups: [
        { name: "Grupo Plange", kind: "" },
        { name: "Grupo Massmann", kind: "" },
        { name: "Frontel", kind: "" },
        { name: "SAESA", kind: "" },
        { name: "DRS Ltda.", kind: "" },
        { name: "Conavicoop", kind: "" },
      ],
    },
    lawyers: {
      title: "Abogados",
      members: [
        {
          initials: "AV",
          photo: "/images/team/alejandro-vargas.jpg",
          name: "Alejandro G. Vargas Casas",
          role: "Socio fundador",
          email: "avargas@vargasyzuniga.cl",
          experience: [
            "Abogado Universidad Católica de Temuco, titulado en Septiembre de 2005.",
            "Magíster en Derecho Privado y Corporativo.",
            "Diplomado en Peritajes Laborales, mención Acoso Laboral, Sexual, Equidad de Género e Inclusión.",
            "Ex Abogado Regional de la Tesorería General de la República.",
            "Profesor de la cátedra de Derecho Procesal Civil, Universidad Católica de Temuco, año 2010.",
            "Áreas de conocimiento: Derecho Civil · Juicio Ejecutivo Tributario · Derecho Laboral y Corporativo.",
          ],
        },
        {
          initials: "MZ",
          photo: "/images/team/monica-zuniga.jpg",
          name: "Mónica Zúñiga Lillo",
          role: "Socia fundadora",
          email: "mzuniga@vargasyzuniga.cl",
          experience: [
            "Abogada Universidad Católica de Temuco, titulada en Noviembre de 2005.",
            "Magíster en Derecho Privado y Corporativo.",
            "Diplomado en Peritajes Laborales, mención Acoso Laboral, Sexual, Equidad de Género e Inclusión.",
            "Profesora de la cátedra de Derecho Civil, Universidad de la Frontera, año 2024.",
            "Áreas de conocimiento: Derecho de Familia · Seguridad Social · Seguros · Derecho del Consumidor · Derecho Laboral y Corporativo.",
          ],
        },
        {
          initials: "NM",
          photo: "/images/team/nicole-munoz.jpg",
          name: "Nicole Muñoz Poblete",
          role: "",
          email: "secretaria@vargasyzuniga.cl",
          experience: [
            "Abogada Universidad Católica de Temuco, titulada en Diciembre de 2025. Diplomada en Derecho Corporativo y Compliance Universidad de Los Andes. (C)",
            "Áreas de conocimiento: Derecho Civil · Regulación de Deuda Tributaria · Derecho Laboral y Corporativo.",
          ],
        },
      ],
    },
    areas: {
      title: "Áreas de Práctica",
      lead: "",
      groups: [
        {
          num: "I",
          name: "Personas y Empresas",
          items: [
            "Constitución de sociedades",
            "Asesoría tributaria",
            "Derecho inmobiliario",
            "Organización patrimonial",

          ],
        },
        {
          num: "II",
          name: "Tramitación de Litigios",
          items: [
            "Civil",
            "Laboral",
            "Tributario",
            "Familia",
            "Tránsito y Ley del Consumidor",
          ],
        },
        {
          num: "III",
          name: "Solicitudes ante el Estado",
          items: [
            "Prescripción de deuda tributaria",
            "Derechos de aprovechamiento de aguas",
            "Derechos mineros",


          ],
        },
      ],
    },
    renata: {
      disponible: "Disponible 24/7",
      contacta: "Contacta a nuestra Asistente",
      converse: "Converse con nuestra asistente",
      agendaTuHora: "AGENDA TU HORA",
      cuentanosCase: "CUÉNTANOS TU CASO",
      conversarAsistente: "Conversar con la asistente",
      reservaAbogado: "Reserva una reunión contactando a nuestra asistente",
      descCorta: "Agenda una reunión. Consulta tus dudas.",
      descLarga: "Agenda una reunión. Consulta tus dudas.",
    },
    contact: {
      title: "Contacto",
      subtitle: "Abogados Ltda.",
      officeLabel: "Oficina",
      address: "Antonio Varas 687, oficina 1010",
      tower: "Torre Sinergia · Temuco",
      phoneLabel: "Teléfono",
      phone: "+56 9 7987 3921",
      emailLabel: "Correo",
      hoursLabel: "Atención",
      hours: "Lunes a Viernes · 09:00 — 18:00",
      formTitle: "Envíenos un mensaje",
      form: {
        name: "Nombre",
        email: "Correo",
        subject: "Asunto",
        message: "Mensaje",
        send: "Enviar",
        sending: "Enviando…",
        success: "Mensaje recibido. Nos pondremos en contacto a la brevedad.",
        error: "No fue posible enviar el mensaje. Inténtelo nuevamente.",
      },
      qrCaption: "Escanear · Contacto directo",
    },
    footer: {
      copy: "© {year} Vargas & Zúñiga Abogados",
      slim: "Antonio Varas 687, of. 1010 · Torre Sinergia · Temuco",
      col2Title: "Otros contenidos",
      col2Item1: "Pensamiento Jurídico",
      col2Item2: "Pro Bono",
      col2Item3: "Selección de talentos",
      col2Item4: "Canal de denuncias",
      col2Item5: "Política de privacidad",
      phoneLabel: "Tel:",
    },
  },
  en: {
    brand: { name: "Vargas & Zúñiga", suffix: "Lawyers" },
    slogan: "Experience · Loyalty · Efficiency",
    nav: {
      home: "Home",
      studio: "The Firm",
      clients: "Clients",
      lawyers: "Lawyers",
      areas: "Practice Areas",
      contact: "Contact",
    },
    arrows: { prev: "Previous section", next: "Next section" },
    home: {
      eyebrow: "Law firm · Temuco · Chile",
      lead: "",
      ctaChat: "Talk to our assistant",
      ctaSections: "Browse the site",
    },
    studio: {
      title: "The Firm",
      paragraphs: [
        "Founded in Temuco, Vargas & Zúñiga brings together two lawyers from Universidad Católica de Temuco and candidates for a Master's in Private Law at Universidad Autónoma de Chile.",
        "We operate with a small, specialized team — every case is attended personally by a partner and every client relationship is built for the long term.",
      ],
      values: [
        { k: "Experience", d: "Over two decades of practice in civil, tax, labor and family matters." },
        { k: "Loyalty", d: "We accompany our clients over time. Each partner attends inquiries personally." },
        { k: "Efficiency", d: "Clear answers, precise strategies and measurable results in every matter." },
      ],
    },
    clients: {
      title: "Some of our representative clients",
      lead: "",
      note: "",
      groups: [
        { name: "Grupo Plange", kind: "" },
        { name: "Grupo Massmann", kind: "" },
        { name: "Frontel", kind: "" },
        { name: "SAESA", kind: "" },
        { name: "DRS Ltda.", kind: "" },
        { name: "Conavicoop", kind: "" },
      ],
    },
    lawyers: {
      title: "Lawyers",
      members: [
        {
          initials: "AV",
          photo: "/images/team/alejandro-vargas.jpg",
          name: "Alejandro G. Vargas Casas",
          role: "Founding partner",
          email: "avargas@vargasyzuniga.cl",
          experience: [
            "Universidad Católica de Temuco — graduated with distinction, 2003.",
            "Franco & Cía. law firm, 2005: civil, banking and corporate litigation.",
            "Regional Attorney, General Treasury of the Republic — La Araucanía, 2006–2010. Over 7,000 enforcement proceedings handled.",
            "Professor of Civil Procedural Law, UC Temuco.",
            "Candidate, Master's in Private Law, Universidad Autónoma de Chile.",
          ],
        },
        {
          initials: "MZ",
          photo: "/images/team/monica-zuniga.jpg",
          name: "Mónica Zúñiga Lillo",
          role: "Founding partner",
          email: "mzuniga@vargasyzuniga.cl",
          experience: [
            "Universidad Católica de Temuco, 2003.",
            "Specialization in Criminal Procedure Reform and Business Law, UC Temuco, 2005.",
            "Professor of Political Law, Universidad Arturo Prat — Victoria, 2006–2008.",
            "Legal counsel for insurance companies in traffic litigation across administrative, civil and criminal courts — 13+ years.",
            "Candidate, Master's in Private Law, Universidad Autónoma de Chile.",
          ],
        },
        {
          initials: "NM",
          photo: "/images/team/nicole-munoz.jpg",
          name: "Nicole Muñoz Poblete",
          role: "",
          email: "secretaria@vargasyzuniga.cl",
          experience: [
            "Lawyer, Universidad Católica de Temuco, graduated December 2025. Diploma in Corporate Law and Compliance, Universidad de Los Andes. (C)",
            "Areas of expertise: Civil Law · Tax Debt Regulation · Corporate and Labor Law.",
          ],
        },
      ],
    },
    areas: {
      title: "Practice Areas",
      lead: "",
      groups: [
        {
          num: "I",
          name: "Individuals & Companies",
          items: [
            "Company incorporation",
            "Tax advisory",
            "Real estate law",
            "Wealth structuring",

          ],
        },
        {
          num: "II",
          name: "Litigation",
          items: ["Civil", "Labor", "Tax", "Family", "Traffic & Consumer Law"],
        },
        {
          num: "III",
          name: "Filings before the State",
          items: [
            "Tax debt prescription",
            "Water-use rights",
            "Mining rights",


          ],
        },
      ],
    },
    renata: {
      disponible: "Available 24/7",
      contacta: "Contact our Assistant",
      converse: "Chat with our assistant",
      agendaTuHora: "BOOK YOUR APPOINTMENT",
      cuentanosCase: "TELL US YOUR CASE",
      conversarAsistente: "Chat with our assistant",
      reservaAbogado: "Book a meeting with our assistant",
      descCorta: "Schedule a meeting. Ask your questions.",
      descLarga: "Schedule a meeting. Ask your questions.",
    },
    contact: {
      title: "Contact",
      officeLabel: "Office",
      address: "Antonio Varas 687, suite 1010",
      tower: "Torre Sinergia · Temuco",
      phoneLabel: "Phone",
      phone: "+56 9 7987 3921",
      emailLabel: "Email",
      hoursLabel: "Hours",
      hours: "Monday to Friday · 09:00 — 18:00",
      formTitle: "Send us a message",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        send: "Send",
        sending: "Sending…",
        success: "Message received. We will get back to you shortly.",
        error: "We couldn't send your message. Please try again.",
      },
      qrCaption: "Scan · Direct contact",
    },
    footer: {
      copy: "© {year} Vargas & Zúñiga Lawyers",
      slim: "Antonio Varas 687, suite 1010 · Torre Sinergia · Temuco",
      col2Title: "Other content",
      col2Item1: "Legal Insights",
      col2Item2: "Pro Bono",
      col2Item3: "Careers",
      col2Item4: "Whistleblower channel",
      col2Item5: "Privacy policy",
      phoneLabel: "Phone:",
    },
  },
};
